import { GENDERS } from '@/common/constants/genders';

const gendersTab = GENDERS().map(el => el.value);

export const rules = {
  required: v => (typeof v === 'string' ? !!v.trim().length : Array.isArray(v) ? !!v.length : !!v) || 'validation.required',
  minLen: (v, minLen) => !v || v.length >= minLen || JSON.stringify({ text: 'validation.minLength', params: { n: minLen } }),
  maxLen: (v, maxLen) => !v || v.length <= maxLen || JSON.stringify({ text: 'validation.maxLength', params: { n: maxLen } }),
  email: v => !v || /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(v) || 'validation.email',
  password: v => !v || /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/.test(v) || 'validation.passwordDescriptionMessage',
  confirmPassword: (v1, v2) => v1 === v2 || 'validation.passwordMissmatch',
  phone: v => !v || /(^$|^[0-9]{7,13}$)/.test(v) || 'validation.phone',
  url: v => !v || /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(v) || 'validation.linkNotValid',
  zipCode: v => !v || /(^$|^[0-9]{4,8}$)/.test(v) || 'validation.zipCode',
  alphaNum: v => /^[a-z0-9]*$/.test(v) || 'validation.alphaNumeric',
  numeric: v => /^[0-9]*$/.test(v) || 'validation.numeric',
  gender: v => gendersTab.includes(v) || 'validation.gender',
  min: (v, min) => v >= min || JSON.stringify({ text: 'validation.min', params: { n: min } }),
  max: (v, max) => v <= max || JSON.stringify({ text: 'validation.max', params: { n: max } }),
  // pillar payment validations
  pillarZipCode: v => !v || /(^$|^[0-9]{5}$)/.test(v) || 'validation.pillarZipCode',
  pillarTaxId: v => !v || /(^$|^[0-9]{9}$)/.test(v) || 'validation.pillarTaxId',
  pillarSSN: v => !v || /(^$|^[0-9]{9}$)/.test(v) || 'validation.pillarSSN',
  dateFormat: v => /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/.test(v) || 'validation.bdDateFormat',
  whiteSpaces: v => !/\s/g.test(v) || 'validation.whiteSpaces',
  latin: v => !v || /^[A-Za-z0-9!@#$%^&*]+$/.test(v) || 'validation.latin',
};

export default (Vue) => {
  Vue.prototype.$rules = rules;
};
